export interface IVatRate {
    sync_key: string;
    sync_last: string;
    vat_id: string;
    vat_rate: number;
    vat_title: string;
}
